/**
 * Type of Good Faith Exam visit.
 *
 * Note: The enum values ("at_home" and "on_demand") represent the visit timing/delivery mode.
 * AT_HOME indicates a scheduled virtual appointment that the patient completes at home.
 * ON_DEMAND indicates an immediate in-person visit that can be completed on-demand at the clinic.
 */
export enum GFEVisitType {
  AT_HOME = "at_home",
  ON_DEMAND = "on_demand",
}
